<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span>任务管理</span>
          <div>
            <el-button size="small" type="primary" @click="openPublish">下发任务</el-button>
            <el-button size="small" @click="tplVisible = true">任务模板</el-button>
            <el-button size="small" @click="openRules">催办规则</el-button>
            <el-button size="small" type="warning" @click="urgeOverdue">逾期催办</el-button>
            <el-button size="small" @click="summary">提交情况汇总</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" @submit.prevent>
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="任务标题" clearable style="width:200px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="load">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="task.id" label="ID" width="80" />
        <el-table-column prop="task.title" label="标题" />
        <el-table-column prop="publisherName" label="发布人" width="120" />
        <el-table-column label="提交进度" width="120">
          <template #default="{row}">{{ row.submittedCount }}/{{ row.receiverCount }}</template>
        </el-table-column>
        <el-table-column prop="task.status" label="状态" width="90">
          <template #default="{row}">{{ ['','已下发','进行中','已提交','已完成'][row.task.status] || row.task.status }}</template>
        </el-table-column>
        <el-table-column prop="task.deadline" label="截止" width="160" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{row}">
            <el-button size="small" @click="urgeSubmit(row.task.id)">催交</el-button>
            <el-button size="small" type="primary" @click="goDetail(row.task.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:12px" background layout="prev, pager, next, total"
        :total="total" :page-size="query.size" @current-change="onPage" />
    </el-card>

    <el-dialog v-model="detailVisible" title="任务接收详情" width="720px">
      <el-table :data="detailList" border v-loading="detailLoading">
        <el-table-column prop="receiver.receiverId" label="接收人ID" width="110" />
        <el-table-column label="状态" width="100">
          <template #default="{row}">{{ recvStatus(row.receiver.receiveStatus) }}</template>
        </el-table-column>
        <el-table-column prop="receiver.receiveTime" label="接收/提交时间" width="170" />
        <el-table-column label="操作" width="120">
          <template #default="{row}">
            <el-button size="small" @click="viewSubmission(row)">看提交</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog v-model="subVisible" title="提交内容" width="560px" append-to-body>
        <pre v-if="subJson" style="white-space:pre-wrap">{{ subJson }}</pre>
        <el-empty v-else description="暂无提交" />
      </el-dialog>
    </el-dialog>

    <!-- 任务模板库（B2） -->
    <el-dialog v-model="tplVisible" title="任务模板库" width="760px">
      <div style="display:flex;justify-content:flex-end;margin-bottom:10px">
        <el-button size="small" type="primary" @click="resetTplForm">新增模板</el-button>
      </div>
      <el-table :data="tplList" border v-loading="tplLoading" size="small">
        <el-table-column prop="title" label="模板标题" min-width="160" />
        <el-table-column label="类型" width="90">
          <template #default="{row}">{{ ['','普通任务','文档提交','表单填写'][row.taskType] || row.taskType }}</template>
        </el-table-column>
        <el-table-column label="适用阶段" width="120">
          <template #default="{row}">{{ row.targetStage ? ['','加添燃料期','聚焦长板期','实现价值期'][row.targetStage] : '通用' }}</template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="220" show-overflow-tooltip />
        <el-table-column prop="sort" label="排序" width="60" />
        <el-table-column label="操作" width="130">
          <template #default="{row}">
            <el-button size="small" @click="editTpl(row)">编辑</el-button>
            <el-button size="small" type="danger" @click="delTpl(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-divider />
      <div style="font-size:13px;color:#909399;line-height:1.8">
        用途：管理员/HR 在后台「下发任务」时，可按模板一键填充标题与内容，避免每次手填。<br />
        模板由管理员在此维护（增删改）；正式下发请在「下发任务」中选择模板。
      </div>
    </el-dialog>

    <!-- 模板编辑 -->
    <el-dialog v-model="tplFormVisible" :title="tplForm.id ? '编辑模板' : '新增模板'" width="560px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="标题" required>
          <el-input v-model="tplForm.title" placeholder="如：暑假班续费流程梳理" />
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="tplForm.taskType" style="width:100%">
            <el-option :value="1" label="普通任务" />
            <el-option :value="2" label="文档提交" />
            <el-option :value="3" label="表单填写" />
          </el-select>
        </el-form-item>
        <el-form-item label="适用阶段">
          <el-select v-model="tplForm.targetStage" clearable placeholder="通用" style="width:100%">
            <el-option :value="1" label="加添燃料期" />
            <el-option :value="2" label="聚焦长板期" />
            <el-option :value="3" label="实现价值期" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="tplForm.content" type="textarea" :rows="4" placeholder="任务说明/步骤，换行用 \n" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="tplForm.sort" :min="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="tplFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="tplSaving" @click="saveTpl">保存</el-button>
      </template>
    </el-dialog>

    <!-- 下发任务（支持按模板一键填充） -->
    <el-dialog v-model="publishVisible" title="下发任务" width="620px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="任务模板">
          <el-select v-model="publishForm.tplId" clearable filterable placeholder="选择模板一键填充（可再改）" style="width:100%" @change="applyTpl">
            <el-option v-for="t in tplList" :key="t.id" :value="t.id" :label="t.title" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input v-model="publishForm.title" placeholder="任务标题" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="publishForm.content" type="textarea" :rows="4" placeholder="任务说明/步骤" />
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="publishForm.taskType" style="width:100%">
            <el-option :value="1" label="普通任务" />
            <el-option :value="2" label="文档提交" />
            <el-option :value="3" label="表单填写" />
          </el-select>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker v-model="publishForm.deadline" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="选填" style="width:100%" />
        </el-form-item>
        <el-form-item label="接收人" required>
          <el-select v-model="publishForm.receiverIds" multiple filterable remote
            :remote-method="searchReceiver" :loading="coachLoading" placeholder="输入姓名/手机号搜索徒弟" style="width:100%">
            <el-option v-for="c in receiverOptions" :key="c.coachid" :value="c.coachid" :label="c.coachname + ' #' + c.coachid" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="publishVisible = false">取消</el-button>
        <el-button type="primary" :loading="publishing" @click="doPublish">下发</el-button>
      </template>
    </el-dialog>

    <!-- 催办漏斗规则（B4） -->
    <el-dialog v-model="ruleVisible" title="催办漏斗规则（每天 09:00 自动执行，走企微 webhook）" width="640px">
      <el-table :data="ruleList" border v-loading="ruleLoading" size="small">
        <el-table-column prop="ruleName" label="规则" width="170" />
        <el-table-column label="阈值(天)" width="110">
          <template #default="{row}">
            <el-input-number v-model="row.thresholdDays" :min="0" size="small" style="width:90px" />
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90">
          <template #default="{row}">
            <el-switch v-model="row.enabled" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="说明" />
      </el-table>
      <div style="margin-top:10px;font-size:13px;color:#909399">
        阈值说明：下发后 N 天未接收 / 接收后 N 天未提交 / 逾期即升级催办。修改后点「保存」生效。
      </div>
      <template #footer>
        <el-button @click="ruleVisible = false">关闭</el-button>
        <el-button type="primary" :loading="ruleSaving" @click="saveRules">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mentorAdminTasks, mentorAdminTaskReceivers, mentorNoticeUrgeSubmit, mentorNoticeUrgeOverdue, mentorNoticeSubmitSummary, mentorTaskTemplates, mentorTaskTemplateSave, mentorTaskTemplateDelete, mentorSearchCoach, mentorTaskPublish, mentorNoticeRules, mentorNoticeRuleSave } from '@/api/mentor'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'MentorTaskManage',
  data () {
    return {
      loading: false,
      total: 0,
      tableData: [],
      query: { page: 1, size: 10, title: '' },
      detailVisible: false, detailLoading: false, detailList: [], subVisible: false, subJson: '',
      operatorId: Number(localStorage.getItem('sysUserId') || localStorage.getItem('userId') || 1),
      // 任务模板库
      tplVisible: false, tplLoading: false, tplList: [],
      tplFormVisible: false, tplSaving: false,
      tplForm: { id: null, title: '', taskType: 1, targetStage: null, content: '', sort: 0 },
      // 下发任务（按模板）
      publishVisible: false, publishing: false, coachLoading: false,
      receiverOptions: [],
      publishForm: { tplId: null, title: '', content: '', taskType: 1, deadline: null, receiverIds: [] },
      // 催办漏斗规则（B4）
      ruleVisible: false, ruleLoading: false, ruleSaving: false, ruleList: []
    }
  },
  mounted () { this.load() },
  methods: {
    async load () {
      this.loading = true
      const params = { page: this.query.page, size: this.query.size }
      if (this.query.title) params.title = this.query.title
      const r = await mentorAdminTasks(params)
      this.loading = false
      if (r && r.code === 200) { this.tableData = r.data.records || []; this.total = r.data.total || 0 }
      else ElMessage.warning((r && r.message) || '查询失败')
    },
    onPage (p) { this.query.page = p; this.load() },
    recvStatus (s) { return ['待接收', '已接收', '退回待提交', '已提交', '已审核'][s] || s },
    async urgeSubmit (taskId) {
      const r = await mentorNoticeUrgeSubmit({ taskId, operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async urgeOverdue () {
      const r = await mentorNoticeUrgeOverdue({ operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async summary () {
      // 商学院整体汇总，不区分城市
      const r = await mentorNoticeSubmitSummary({ operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async goDetail (taskId) {
      this.detailVisible = true; this.detailLoading = true; this.detailList = []
      const r = await mentorAdminTaskReceivers({ taskId })
      this.detailLoading = false
      if (r && r.code === 200) this.detailList = r.data || []
      else ElMessage.warning((r && r.message) || '查询失败')
    },
    viewSubmission (row) { this.subVisible = true; this.subJson = JSON.stringify(row.submission || {}, null, 2) },
    // ============ 任务模板库（B2）============
    async loadTpls () {
      this.tplLoading = true
      const r = await mentorTaskTemplates({ page: 1, size: 100 })
      this.tplLoading = false
      if (r && r.code === 200 && r.data) this.tplList = r.data.records || []
      else ElMessage.warning((r && r.message) || '模板加载失败')
    },
    resetTplForm () {
      this.tplForm = { id: null, title: '', taskType: 1, targetStage: null, content: '', sort: 0 }
      this.tplFormVisible = true
    },
    editTpl (row) {
      this.tplForm = {
        id: row.id, title: row.title, taskType: row.taskType || 1,
        targetStage: row.targetStage, content: row.content || '', sort: row.sort || 0
      }
      this.tplFormVisible = true
    },
    async saveTpl () {
      if (!this.tplForm.title) { ElMessage.warning('请填写模板标题'); return }
      this.tplSaving = true
      const r = await mentorTaskTemplateSave(this.tplForm)
      this.tplSaving = false
      if (r && r.code === 200) { ElMessage.success('已保存'); this.tplFormVisible = false; this.loadTpls() }
      else ElMessage.warning((r && r.message) || '保存失败')
    },
    async delTpl (row) {
      try {
        await ElMessageBox.confirm('确认删除模板「' + row.title + '」？', '提示', { type: 'warning' })
        const r = await mentorTaskTemplateDelete({ id: row.id })
        if (r && r.code === 200) { ElMessage.success('已删除'); this.loadTpls() }
        else ElMessage.warning((r && r.message) || '删除失败')
      } catch (e) {
        /* 用户取消删除，忽略 */
      }
    },
    // ============ 下发任务（B2：按模板一键填充）============
    openPublish () {
      this.publishForm = { tplId: null, title: '', content: '', taskType: 1, deadline: null, receiverIds: [] }
      this.receiverOptions = []
      this.publishVisible = true
      this.loadTpls() // 拉最新模板供选择
    },
    applyTpl (tplId) {
      const t = this.tplList.find(x => x.id === tplId)
      if (t) {
        this.publishForm.title = t.title
        this.publishForm.content = t.content || ''
        this.publishForm.taskType = t.taskType || 1
      }
    },
    async searchReceiver (kw) {
      if (!kw) return
      this.coachLoading = true
      const r = await mentorSearchCoach({ name: kw })
      this.coachLoading = false
      if (r && r.code === 200 && r.data) {
        this.receiverOptions = Array.isArray(r.data) ? r.data : (r.data.records || [])
      }
    },
    async doPublish () {
      const f = this.publishForm
      if (!f.title || !f.receiverIds || !f.receiverIds.length) {
        ElMessage.warning('请填写标题并选择接收人')
        return
      }
      this.publishing = true
      const params = {
        title: f.title,
        taskType: f.taskType,
        content: f.content,
        publisherId: this.operatorId,
        publisherType: 0, // 0=管理员代发
        deadline: f.deadline,
        // 逗号串传参：axios 数组默认 receiverIds[]=x 与后端 @RequestParam List 不匹配，逗号串为 Spring 原生支持
        receiverIds: f.receiverIds.join(',')
      }
      const r = await mentorTaskPublish(params)
      this.publishing = false
      if (r && r.code === 200) {
        ElMessage.success('任务已下发，接收人 ' + (r.data ? r.data.receiverCount : f.receiverIds.length) + ' 人')
        this.publishVisible = false
        this.load()
      } else {
        ElMessage.warning((r && r.message) || '下发失败')
      }
    },
    // ============ 催办漏斗规则（B4）============
    async openRules () {
      this.ruleVisible = true
      this.ruleLoading = true
      const r = await mentorNoticeRules()
      this.ruleLoading = false
      if (r && r.code === 200) this.ruleList = r.data || []
      else ElMessage.warning((r && r.message) || '规则加载失败')
    },
    async saveRules () {
      this.ruleSaving = true
      for (const rule of this.ruleList) {
        const r = await mentorNoticeRuleSave(rule)
        if (!r || r.code !== 200) {
          this.ruleSaving = false
          ElMessage.warning((r && r.message) || '保存失败：' + rule.ruleName)
          return
        }
      }
      this.ruleSaving = false
      ElMessage.success('规则已保存')
      this.ruleVisible = false
    }
  }
}
</script>

<style scoped>
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
</style>
